import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Response } from '../models/response';
import { environment } from 'src/environments/environment';

const aspAPI = `${environment.api}/aspirations`;

@Injectable({
  providedIn: 'root'
})
export class AspirationService {
  constructor(private http: HttpClient) {}

  //index delle aspirazioni
  getAspirations() {
    return of({ result: [] } as Response<any>);
  }

  //creazione delle aspirazioni
  storeAspiration(
    description: string,
    is_limitation: boolean,
    is_checked: boolean
  ): Observable<Response<any>> {
    let data = {};
    Object.assign(data, {
      description: description,
      is_limitation: is_limitation,
      is_checked: is_checked
    });
    return of({ result: data } as Response<any>);
  }

  //modifica la descrizione di una aspirazione, il check e la priorità
  updateASpiration(
    aspirationId: number,
    description: string,
    checked: boolean
  ): Observable<Response<any>> {
    let data = {};
    Object.assign(data, { description: description, is_checked: checked });
    return of({ result: data } as Response<any>);
  }

  //modifica la posizione delle aspirazioni
  switch(aspirationArray: Array<any>): Observable<Response<any>> {
    return of({ result: aspirationArray } as Response<any>);
  }

  deleteAspiration(aspirationId: number): Observable<Response<any>> {
    return of({ result: null } as Response<any>);
  }
}
